export default "__VITE_PUBLIC_ASSET__86670327__"